module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_1_main-6a5cb399fbad033f99cfdc59460ad8ab.png";